import gql from "graphql-tag";

import {gqlOp, type GqlOperation} from "@khan/data-gql-core";

import type {getIsClassCleverLibrarySyncedType} from "./__graphql-types__/index.ts";

export const GET_IS_CLASS_CLEVER_LIBRARY_SYNCED_QUERY: GqlOperation<
    getIsClassCleverLibrarySyncedType["response"],
    getIsClassCleverLibrarySyncedType["variables"]
> = gqlOp(gql`
    query getIsClassCleverLibrarySynced($classDescriptor: String!) {
        classroom: classroomByDescriptor(descriptor: $classDescriptor) {
            id
            cacheId
            isCleverLibrarySynced
        }
    }
`);
